import React from 'react'
import getConfig from 'next/config'

import { style } from '../../../../components/Common/Index.style'
import Page from '../../../../components/Page/Page'
import PageHeader from '../../../../components/PageHeader/PageHeader'
import Content from '../../../../components/Content/Content'
import SectionTitle from '../../../../components/SectioinTitle'
import BackBtn from '../../../../components/Common/BackBtn'
import BreadCrumb from '../../../../components/Breadcrumbs/Breadcrumbs'

const { publicRuntimeConfig } = getConfig()
const basePath = publicRuntimeConfig.basePath

const pageTitle = '運転者も歩行者も交通安全を意識した行動を！ | 新潟県民だより'

const Home = () => {
  return (
    <Page title={pageTitle}>
      <PageHeader pageTitle="県からのお知らせ" />
      <SectionTitle sectionTitle="運転者も歩行者も交通安全を意識した行動を！" />
      <Content css={style.content}>
        <BreadCrumb
            lists={[
              {
                name: "HOME",
                path: "/"
              },
              {
                name: "2023夏号 No.163 目次",
                path: "/no163"
              },
              {
                name: "県からのお知らせ"
              }
            ]}
          />
        
        
        <p>夏は夏休みなどの解放感や、暑さによる疲労を原因とした交通事故が増えるおそれがあります。次の３つに特に気をつけましょう。</p>
        
        <ul>
          <li><span css={style.emphasisWeight}>１ 横断歩行者等の交通事故防止</span></li>
          <li><span css={style.emphasisWeight}>２ 疲労運転の防止</span></li>
          <li><span css={style.emphasisWeight}>３ 飲酒運転の根絶</span></li>
        </ul>
        
        <br />
        <p>詳しい内容は…</p>
        <div>
          <img
            src={`${basePath}/no163/img/2-8.png`}
            alt="新潟県　夏の交通事故　検索"
            css={style.img(268)}
          />
        </div>
        
        <div>
          <img
            src={`${basePath}/no163/img/2-7.png`}
            alt="新潟県交通安全 マスコット ルルちゃん"
            css={style.img(150)}
          />
          <p css={style.imgCap}>新潟県交通安全 マスコット <br />ルルちゃん</p>
        </div>
        
        <h3 css={style.subTitle01}>安全運転・チャレンジ100 参加者大募集中</h3>
        <p>５人１チームで100日間の無事故・無違反と、横断歩行者を守る運転の達成を目指します。達成チームには抽選で豪華特別賞も。</p>
        <p><span css={style.emphasisWeight}>申込は８月31日まで。ぜひご参加ください！</span></p>
        
        <p>詳しくは
          <a
            href="https://www.pref.niigata.lg.jp/sec/kenminseikatsu/1356751684647.html"
            target="_blank"
            rel="noreferrer"
          >
            <span>こちら</span>
          </a>
          から
        </p>
        
        <p>【問い合わせ】交通安全対策室&emsp;電話：<a href="tel:025-280-5136">025-280-5136</a></p>


        <BackBtn href={"/no163"} />
      </Content>
    </Page>
  )
}
export default Home
